// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Router from "next/router";
import * as NextRecaptchaV3 from "next-recaptcha-v3";
import * as MediaQuery$PorterinUtils from "../../../../../../node_modules/@porterin/utils/src/hooks/MediaQuery.mjs";
import * as UtmHelper$PorterinFeature from "../../core/helpers/UtmHelper.mjs";
import * as AuthContext$PorterinFeature from "../../../contexts/auth-context/AuthContext.mjs";
import * as CityContext$PorterinFeature from "../../../contexts/city-context/CityContext.mjs";
import * as CountryHelpers$PorterinUtils from "../../../../../../node_modules/@porterin/utils/src/helpers/CountryHelpers.mjs";
import * as ModalContext$PorterinFeature from "../../../contexts/modal-context/ModalContext.mjs";
import * as SharedHelper$PorterinFeature from "../../core/helpers/SharedHelper.mjs";
import * as RecaptchaContext$PorterinFeature from "../../../contexts/recpatcha-context/RecaptchaContext.mjs";
import * as SpotEstimateFormModuleScss from "./styles/SpotEstimateForm.module.scss";
import * as SpotEstimateFormState$PorterinFeature from "./components/form/SpotEstimateFormState.mjs";
import * as SpotEstimateInputModuleScss from "./styles/SpotEstimateInput.module.scss";
import * as SpotEstimateFormFieldCmp$PorterinFeature from "./components/SpotEstimateFormFieldCmp.mjs";
import * as SpotEstimateFormInterface$PorterinFeature from "./components/form/SpotEstimateFormInterface.mjs";

var styles = SpotEstimateFormModuleScss;

var default_input_styles = SpotEstimateInputModuleScss;

function SpotEstimateFormCmp(Props) {
  var has_round_cornersOpt = Props.has_round_corners;
  var service_category = Props.service_category;
  var spot_fare_estimate_vm = Props.spot_fare_estimate_vm;
  var has_round_corners = has_round_cornersOpt !== undefined ? has_round_cornersOpt : false;
  var match = Router.useRouter();
  var locale = match.locale;
  var asPath = match.asPath;
  var recaptcha_execute = NextRecaptchaV3.useReCaptcha();
  var recaptcha_context = RecaptchaContext$PorterinFeature.useRecaptchaContext(undefined);
  var citySelectedContext = CityContext$PorterinFeature.useCitySelectedContext(undefined);
  var modalContext = ModalContext$PorterinFeature.useModalContext(undefined);
  var match$1 = AuthContext$PorterinFeature.useAuthContext(undefined);
  var user = match$1.user;
  var is_authenticated = match$1.is_authenticated;
  var isDesktop = MediaQuery$PorterinUtils.useMediaQuery("(min-width: 560px)");
  var match$2 = React.useState(function () {
        return SpotEstimateFormState$PorterinFeature.initialFormState(user);
      });
  var setPreviousInput = match$2[1];
  var match$3 = React.useState(function () {
        
      });
  var setResponse = match$3[1];
  var form = SpotEstimateFormInterface$PorterinFeature.Form.useForm(match$2[0], {
        error_msgs: spot_fare_estimate_vm.errors_msgs,
        country: CountryHelpers$PorterinUtils.countryCodeFromLocale(locale)
      }, (function (output, callbacks) {
          var match = UtmHelper$PorterinFeature.getUtmStringFromPath(asPath);
          SharedHelper$PorterinFeature.triggerAcceptAllCookies(locale);
          SpotEstimateFormState$PorterinFeature.onFormSubmit(output, callbacks, service_category, citySelectedContext.category, recaptcha_execute, setResponse, isDesktop, citySelectedContext.city_selected, recaptcha_context, modalContext.toggleModal, is_authenticated, match[0], match[1], locale, citySelectedContext.city_selected);
        }));
  React.useEffect((function () {
          var match = form.status;
          var exit = 0;
          if (typeof match === "number") {
            if (match !== /* Editing */0) {
              exit = 1;
            }
            
          } else if (match.TAG !== /* Submitting */0) {
            exit = 1;
          }
          if (exit === 1) {
            Curry._1(setPreviousInput, (function (param) {
                    return form.input;
                  }));
            Curry._1(form.reset, undefined);
          }
          
        }), [form.status]);
  return React.createElement("div", {
              className: has_round_corners ? "" + styles["rounded-corners"] + " " + styles["spot-fare-estimate-container"] + "" : styles["spot-fare-estimate-container"]
            }, React.createElement(SpotEstimateFormFieldCmp$PorterinFeature.make, {
                  form: form,
                  response: match$3[0],
                  service_category: service_category,
                  city_selected_context: citySelectedContext,
                  spot_fare_estimate_vm: spot_fare_estimate_vm
                }));
}

var make = SpotEstimateFormCmp;

export {
  styles ,
  default_input_styles ,
  make ,
}
/* styles Not a pure module */
